'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabs = require('./components/tabs');

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tabs).default;
  }
});

var _tabContent = require('./components/tab-content');

Object.defineProperty(exports, 'TabContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tabContent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-tabs/lib/index.js
// module id = 1199
// module chunks = 0